import interceptors from "./interceptors";

const fetchFiles = (category, limit) => {
  return interceptors({
    url: `/documents/document/${category}${!!limit ? "?latest=" + limit : ""}`,
    method: "GET",
  });
};

const downloadFile = (category, id) => {
  return interceptors({
    url: `/documents/document/${category}/${id}/download`,
    method: "GET",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadFileByCategory = (data) => {
  return interceptors({
    url: "/documents/document",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const fetchLastFiles = (limit) => {
  return interceptors({
    url: `/documents/document${!limit ? "" : `?latest=${10}`}`,
    method: "GET",
  });
};

const deleteFile = (category, uuid) => {
  return interceptors({
    url: `/documents/document/${category}/${uuid}/`,
    method: "DELETE",
  });
};

export {
  downloadFile,
  fetchFiles,
  uploadFileByCategory,
  fetchLastFiles,
  deleteFile,
};
